// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__67jmP","Label":"Checkbox_Label__21DDF","InputElement":"Checkbox_InputElement__3fwfH","Invalid":"Checkbox_Invalid__2NYuJ"};